const startDate = ref(null);
const intervalId = ref(null);
const leftDays = ref('00');
const leftHours = ref('00');
const leftMinutes = ref('00');
const leftSeconds = ref('00');
const isStarted = ref(false);

export default function useTimeLeft () {  
  function init (dateString) {
    const utcTime = new Date(dateString.replace(' ', 'T') + 'Z');
    startDate.value = Math.floor(utcTime.getTime() / 1000);
    checkStatus();
    runInterval();
  }

  function runInterval () {
    intervalId.value = setInterval(() => {
      isStarted.value = true;
      checkStatus();
      getLeftTime();
    }, 1000)
  }

  function checkStatus () {
    const now = Math.floor(Date.now() / 1000);
    if (now >= startDate.value) {
      leftDays.value = '00';
      leftHours.value = '00';
      leftMinutes.value = '00';
      leftSeconds.value = '00';
      clearInterval(intervalId.value);
    }
  }

  function getLeftTime () {
    const now = Date.now();
    const target = startDate.value * 1000;

    if (target <= now) {
      leftDays.value = '00';
      leftHours.value = '00';
      leftMinutes.value = '00';
      leftSeconds.value = '00';
      return;
    }

    const diff = target - now;
    const totalSeconds = Math.floor(diff / 1000);

    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    leftDays.value = days < 10 ? '0' + days : String(days);
    leftHours.value = hours < 10 ? '0' + hours : String(hours);
    leftMinutes.value = minutes < 10 ? '0' + minutes : String(minutes);
    leftSeconds.value = seconds < 10 ? '0' + seconds : String(seconds);
  }

  function clear () {
    if (intervalId.value) clearInterval(intervalId.value);
  }

  return { init, clear, leftDays, leftHours, leftMinutes, leftSeconds, isStarted }
}